import isMobile from 'ismobilejs';
import Cookies from 'js-cookie';
import platform from 'platform';

import { DeviceOs, DeviceOsValues } from '@/logic/main/types';
import Window from '@/ports-backend/Window';

function getDeviceTypeFromBrowser({
  phone,
  tablet,
}: {
  phone: boolean;
  tablet: boolean;
}) {
  if (phone) {
    return 'mobile';
  } else if (tablet) {
    return 'tablet';
  }

  return 'desktop';
}

function getDeviceOs(): DeviceOs {
  const userOSFamily = platform.os?.family?.toLowerCase();
  if (!userOSFamily) return null;
  const supportedOSystems = Object.values(DeviceOsValues);
  const userOs = supportedOSystems.find(os => userOSFamily.includes(os));
  return userOs || null;
}

const isNative = () => {
  return !!Window.invoke.getAssemblerContext().is_native;
};

const deviceDetection = {
  invoke: {
    getDeviceInfo: () => {
      const deviceType = isMobile();
      const deviceInfo = {
        isNative: isNative(),
        nativeDeviceOs: null,
        appVersion: null,
        deviceType: getDeviceTypeFromBrowser(deviceType),
        deviceOs: getDeviceOs(),
      };

      try {
        const cookie = Cookies.get('wh_device');
        const deviceCookie = cookie ? JSON.parse(cookie) : {};
        deviceInfo['nativeDeviceOs'] = deviceCookie.device_os
          ? deviceCookie.device_os.toLowerCase()
          : null;
        deviceInfo['appVersion'] = deviceCookie.app_version
          ? deviceCookie.app_version
          : null;
      } catch (e) {
        console.error('Could not parse cookie "wh_device".');
      }

      return deviceInfo;
    },
  },
};

export default deviceDetection;
